import script from "./BookingList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingList.vue?vue&type=script&setup=true&lang=ts"

import "./BookingList.vue?vue&type=style&index=0&id=587745fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-587745fa"]])

export default __exports__